/** @returns a promise that resolves after the provided delay in ms */
export function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
